import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);

		this.events = {
			click: {
				search: "openSearch",
				link: "openMenu",
				burger: "openBurgerMenu",
			},
		};
	}

	init() {
		this.$links = this.$("link");
		this.$burgerMenu = this.$("burger-menu")[0];

		this._closeHandler = this.closeMenu.bind(this);
		document.addEventListener("overlay:click", this._closeHandler);

		this._keydownHandler = this.keydown.bind(this);
		document.addEventListener("keydown", this._keydownHandler);
	}

	openSearch() {
		this.call("openSearch", "search");
	}

	openMenu(e) {
		// Check if the clicked element is already active
		const isAlreadyActive = e.currentTarget.classList.contains("is-active");

		// Remove is-active class from all links
		this.$links.forEach((link) => {
			link.classList.remove("is-active");
		});

		// If the clicked element wasn't active, add the class
		if (!isAlreadyActive) {
			e.currentTarget.classList.add("is-active");
		}

		// Get all menu instances
		const allMenus = document.querySelectorAll(".c-menu");
		const clickedMenu = e.currentTarget.querySelector(".c-menu");

		// Check if the clicked menu is already active
		const isMenuAlreadyActive = clickedMenu.classList.contains("is-active");

		// Remove is-active class from all menus except the clicked one
		allMenus.forEach((menu) => {
			if (menu !== clickedMenu) {
				menu.classList.remove("is-active");
			}
		});

		// Wait for animation to finish before adding is-active class to clicked menu
		setTimeout(() => {
			clickedMenu.classList.toggle("is-active");

			// If the menu was already active and is now being closed, close the overlay
			if (isMenuAlreadyActive) {
				this.call("close", {}, "overlay");
				window.lenis.start();
			} else {
				this.call("open", {}, "overlay");
				window.lenis.stop();
			}
		}, 150);

		this.call("closeSearch", "search");
	}

	closeMenu() {
		const allMenus = document.querySelectorAll(".c-menu");
		allMenus.forEach((menu) => {
			menu.classList.remove("is-active");
		});

		this.$links.forEach((link) => {
			link.classList.remove("is-active");
		});

		this.call("close", {}, "overlay");
		window.lenis.start();
	}

	openBurgerMenu(e) {
		const isMenuAlreadyActive = e.currentTarget.classList.contains("is-active");

		if (isMenuAlreadyActive) {
			e.currentTarget.classList.remove("is-active");
			this.$burgerMenu.classList.remove("is-active");
			window.lenis.start();
		} else {
			e.currentTarget.classList.add("is-active");
			this.$burgerMenu.classList.add("is-active");
			window.lenis.stop();
		}
	}

	keydown(event) {
		if (event.keyCode == 27) {
			this.closeMenu();
		}
	}

	destroy() {}
}
